module.exports = __webpack_public_path__ + "static/media/download.dbfe7e69.svg";